import './util/queryStringParser'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AsyncComputed from 'vue-async-computed'
import { loadEnv } from './util/env'
import { setLang } from './lang'

// this somehow affects material ui icons
import 'vue-material-design-icons/styles.css'

Vue.config.productionTip = false

Vue.use(AsyncComputed)

const log = (...args) => console.log(...args)

const branch = window.APP_BRANCH || '<no branch>'
const version = window.APP_VERSION || '<no version>'

import { get, post } from './util/ajax'

window.api = { get, post }

log(`App version ${branch} / ${version}`)

async function start() {
	await loadEnv()

	setLang()

	new Vue({
		router,
		store,
		render: h => h(App),
		el: '.App'
	})
}
start()
